import { HealthDataMeasurementSource, HealthDataMeasurementType, Measurement } from '@src/types'
import { Measurement as EventMeasurement } from '@src/screens/Events/models/events.types'
import { MeasurementValues } from '../Measurements/types'

export const isInputValueValid = (value: string | undefined | null) => {
  if (value === undefined || value === null || value.trim() === '') {
    return false
  }
  return true
}

export const getDisplayMeasurementValue = (measurement: Measurement) => {
  if (measurement.value) {
    return measurement.value.toString()
  }

  if (measurement.values) {
    if (
      measurement.healthDataType === HealthDataMeasurementType.BloodPressure &&
      'systolic' in measurement.values &&
      'diastolic' in measurement.values
    ) {
      return `${measurement.values.systolic}/${measurement.values.diastolic}`
    } else if ('value' in measurement.values) {
      return measurement.values.value.toString()
    }
  }
}

export const mapMeasurementToEvent = (measurement: Measurement): EventMeasurement => {
  return {
    id: measurement.id,
    type: measurement.healthDataType,
    title: measurement.title,
    value: measurement.value ?? null,
    values: (measurement.values as MeasurementValues) ?? undefined,
    units: measurement.units,
    description: measurement.description,
    externalSource: HealthDataMeasurementSource.Nutrisense,
    occurredAt: measurement.occurredAt,
    createdAt: measurement.createdAt,
    __typename: 'Measurement', // MeasurementTypeName
    fake: false,
  }
}
